var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseEmailPart',_vm._b({staticClass:"body-image-container part-inner-container"},'BaseEmailPart',_vm.$attrs,false),[_c('img',{attrs:{"src":_vm.imageSrc,"alt":_vm.imageAlt}})])}
var staticRenderFns = []

export { render, staticRenderFns }